import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { UserInformationService } from '../../services/user-informations.service';
import {
  DxButtonModule,
  DxDateBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { Observable, take, tap, Subject, takeUntil, filter } from 'rxjs';

import {
  GetGorevSayac_Request,
  PersonelBilgiDto,
  GetFormMetadata_Request,
} from '../../models/ortak.dtos';
import { GenOrtManuelService } from 'libs/gen/src/lib/services/moduls-manuel-services/ort/gen-ort-manuel.service';
import {
  GetResim_Request,
  ImageResponse,
  ResimSourceType,
} from '../../../../../../../libs/gen/src/lib/models/genpg.models';
import { Router } from '@angular/router';
import { GenBildirimComponent } from '../../gen-bildirim/gen-bildirim.component';
import { HomePopupsComponent } from '../home-popups/home-popups.component';
import { DkNavService } from '../../services/dk-nav.service';
import { OrtakService } from '../../services/ortak.service';
import { DkDxDataCtlTableComponent } from '../components';
import { OpeningScreenService, PersonelIzinOzeti } from './opening-screen.service';
import { ColumnModel } from '../../models/dx-data-table.model';
import DataSource from 'devextreme/data/data_source';
import { AuthService } from '@dabnet-kamu/libs/auth';
// eski hâli (06.10.2026): bağlantı artık dk-main'de RealtimeService ile kuruluyor
// import { ServerEventService } from '../../services/server-event.service';
import notify from 'devextreme/ui/notify';

/** Telefon Rehberi satırı (vBimPersonelTelefonDetay + görünüm alanları). */
interface RehberKisi {
  PersonelKod?: number;
  AdiSoyadi?: string;
  Gorev?: string;
  Dahili?: string;
  TelefonNo?: string;
  harf: string;
  renk: string;
  ara: string;
  adP: AramaParca[];
  birimP: AramaParca[];
  dahiliP: AramaParca[];
}
interface AramaParca { m: string; e: boolean; }
interface RehberBirim { ad: string; kisa: string; sayi: number; }

@Component({
  selector: 'dk-opening-screen',
  standalone: true,
  imports: [
    CommonModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDateBoxModule,
    GenBildirimComponent,
    HomePopupsComponent,
    DkDxDataCtlTableComponent

  ],
  templateUrl: './opening-screen.component.html',
  styleUrls: ['./opening-screen.component.scss'],
})
export class OpeningScreenComponent implements OnInit {
  public num = 1;
  public isPersonel: boolean;
  PersonelInfo: PersonelBilgiDto;

  personelServiceDone: boolean = false;
// DKM-5023 Clara: eski hâli (sabit örnek değerler)
// public kalanIzinGun = 15;
// public yillikIzin = 20;
//   public kullanilan = 5;
//   public izinKalanGun = this.yillikIzin - this.kullanilan;
  /** DKM-5023: vIkaPersonelIzinHakedis'ten; null = yüklenemedi, undefined = yükleniyor. */
  public izinOzeti: PersonelIzinOzeti | null | undefined = undefined;
  profilePicture: string;
  isPopoverVisible = false;
  isHomePopups = false;
  // Analiz Merkezi eski hâli: 6 kart (3x2), Duyurular ile başlıyordu.
  // 4x2: her satırın başına yeni sütun — üstte Analiz Merkezi, altta şimdilik boş yer (bos).
  // fa: ana ekran yenileme (02.10.2026) kutu ikonu (FontAwesome, tema vurgusunda); icon (emoji) eski hâli için duruyor.
  public sideBarItems: any[] = [
    { icon: '📊', value: 'AnalizMerkezi', text: 'Analiz Merkezi', fa: 'fa-chart-column' },
    { icon: '📢', value: 'Duyuru', text: 'Duyurular', fa: 'fa-bullhorn' },
    { icon: '📋', value: 'GenReportTalepForm', text: 'Rapor Talepleri', routeLink: '/GEN/GenReportTalepForm', fa: 'fa-clipboard-list' },
    { icon: '🛩️', value: 'İzin', text: 'İzinli Personeller', fa: 'fa-plane-departure' },
    { value: 'Bos', bos: true },
    { icon: '🤝', value: 'Destek', text: 'Destek Taleplerim', fa: 'fa-handshake' },
    { icon: '🗓️', value: 'Takvim', text: 'Takvimim', fa: 'fa-calendar-days' },
    { icon: '📝', value: 'İş', text: 'İş Listem', fa: 'fa-list-check' },
    // { icon: '🔔', value: 'GenBildirim', text: 'Bildirimler' },
    // { icon: '✍🏻', value: 'BysImza', text: 'Bekleyen İmza', listeTuru: 3 },
    // { icon: '📮', value: 'BysHavale', text: 'Bekleyen Havale' },
    // { icon: '📋', value: 'BysGidenEvrakKayit', text: 'Giden Evrak', listeTuru: 4 },
    // { icon: '↩️', value: 'BysTaslakRed', text: 'Red Edilen Yazılar', listeTuru: 3 },
    // { icon: '📋', value: 'BysBirimGelenEvrakKayit', text: 'Gelen Evrak' },
  ];
  selectedItem: any = {
    value: 'GenReportTalepForm',
    text: 'Rapor Talepleri',
  };
  public profileItems: any[] = [];

   dataSource: DataSource;
   columnList: ColumnModel[];

  // ---- Telefon Rehberi (ana ekran yenileme 02.10.2026) ----
  rehber: RehberKisi[] = [];
  suzulmus: RehberKisi[] = [];
  birimler: RehberBirim[] = [];
  aramaMetni = '';
  seciliBirim: string | null = null;
  rehberYuklendi = false;
  /** PersonelKod → base64 (null: fotoğraf yok / yükleniyor). Görünen satırlar için yüklenir. */
  private fotolar = new Map<number, string | null>();
  private fotoKuyrugu: number[] = [];
  private fotoCalisan = 0;
  private static readonly SATIR_YUKSEKLIK = 38;
  private static readonly AVATAR_RENKLERI = ['#2563eb', '#059669', '#7c3aed', '#ea580c', '#db2777', '#0891b2', '#4f46e5', '#0d9488'];

  private destroy$ = new Subject<void>();
  constructor(
    private userService: UserInformationService,
    private ortManuelService: GenOrtManuelService,
    private router: Router,
    private navService: DkNavService,
    private ortakService: OrtakService,
    public openingScreenService: OpeningScreenService,
    private authService: AuthService,
    // eski hâli (06.10.2026): private serverEventService: ServerEventService
  ) {}

  async ngOnInit() {
    this.openingScreenService.getDlist('vBimPersonelTelefonDetay');
        this.dataSource = this.openingScreenService.getvBimPersonelTelefonDetayData();
        this.rehberYukle();
        this.openingScreenService.gridCtlvBimPersonelTelefonDetay$
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            if (res) {
              this.columnList = this.ortakService.setRecursiveFieldData([res],false);
            }
          });

    try {
      this.setTimeOutSayac();
      // 16.10.2026 bellek: eski hâli (ekran kapansa da zamanlayıcı 2 dk boyunca eski bileşeni ve profil resmini
      // tutuyor, süre dolunca kapanmış ekran için sayaç isteği atıyordu)
      // setTimeout(() => {
      //   this.setTimeOutSayac();
      // }, 120000);
      this.sayacZamanlayici = setTimeout(() => {
        this.setTimeOutSayac();
      }, 120000);

      const res = await this.userService.getPersonelInfo();

      if (res?.response.result) {
        // DKM-5104 Cedric: eski hâli
        // this.PersonelInfo = res?.response?.personelBilgi;
        // DKM-5104: personeli olmayan kullanıcı (personelKod yok ya da tür 0) → PersonelInfo boş kalır;
        // kart yine çizilir ama boş/pasif (gri silüet, Bordrolarım/İzinlerim kapalı), sağ taraf ve rehber normal gelir.
        const personelBilgi = res?.response?.personelBilgi;
        this.PersonelInfo = personelBilgi?.personelKod && personelBilgi?.personelTurKod !== 0 ? personelBilgi : undefined;
      }

      // DKM-5023: izin özeti ekranı bekletmeden arkada yüklenir.
      this.izinOzetiYukle(this.PersonelInfo?.personelKod);

      // DKM-5104 Cedric: eski hâli (personel yokken de resim isteniyordu)
      // const personelResim = await this.ortManuelService.GetResim_Request(
      const personelResim = !this.personelVar ? null : await this.ortManuelService.GetResim_Request(
        new GetResim_Request({
          resimKod: this.PersonelInfo?.personelKod,
          sourceType: ResimSourceType.personel,
          base64Yn: 1,
        })
      );

      if (res?.response.result) {
        this.isPersonel = res?.response?.isPersonel;
        if (this.PersonelInfo) {
          this.profileItems = [
            this.addItem(
              this.PersonelInfo?.tckn,
              'Tc Kimlik No',
              this.PersonelInfo?.tckn
            ),
            this.addItem(
              this.PersonelInfo?.kurumSicilNo,
              'Kurum Sicil',
              this.PersonelInfo?.kurumSicilNo
            ),
            this.addItem(
              this.PersonelInfo?.dogumTarih,
              'Doğum Tarihi',
              formatDate(this.PersonelInfo?.dogumTarih, 'dd-MM-yyyy', 'en-US')
            ),
            this.addItem(
              this.PersonelInfo?.ilkGirisTarih,
              'İşe Giriş',
              formatDate(
                this.PersonelInfo?.ilkGirisTarih,
                'dd-MM-yyyy',
                'en-US'
              )
            ),
            this.addItem(
              this.PersonelInfo?.gorevBirimAd,
              'Görev Birimi',
              this.PersonelInfo?.gorevBirimAd
            ),
            this.addItem(
              this.PersonelInfo?.personelTurAd,
              'Personel Türü',
              this.PersonelInfo?.personelTurAd
            ),
          ].filter((item) => item);
        }
      }
      if (personelResim?.response?.result) {
        this.profilePicture = personelResim?.response?.base64;
      }

      // eski hâli (06.10.2026): açılış ekranına her gelişte yeni bağlantı + yeni ping zamanlayıcısı açılıyordu,
      // token bir kez yakalanıyordu. Bağlantı artık dk-main'de RealtimeService.baslat() ile tek sefer kuruluyor.
      // this.authService.accessToken$()
      //       .pipe(
      //         filter(Boolean),
      //         take(1),
      //         takeUntil(this.destroy$)
      //       )
      //       .subscribe(token => {
      //         this.serverEventService.startConnection(token);
      //       });
    } catch (error) {
      console.error('Error fetching personel info:', error);
    } finally {
      this.personelServiceDone = true;
    }
  }
  /** DKM-5023: Memur → bu yıl + önceki yıl, diğerleri → tüm yıllar (kural serviste). */
  private izinOzetiYukle(personelKod: number) {
    if (!personelKod) {
      this.izinOzeti = null;
      return;
    }
    this.openingScreenService
      .getIzinOzeti(personelKod)
      .then((ozet) => (this.izinOzeti = ozet))
      .catch(() => (this.izinOzeti = null));
  }

  /** DKM-5104: kullanıcının personel kaydı var mı (yoksa kart boş ve pasif çizilir). */
  get personelVar(): boolean {
    return !!this.PersonelInfo?.personelKod;
  }

  /** Kart başlığındaki fotoğraf yoksa baş harfler. */
  get basHarfler(): string {
    const harfler = [this.PersonelInfo?.ad, this.PersonelInfo?.soyad].filter(Boolean).map((x) => String(x)[0]).join('');
    return harfler.toLocaleUpperCase('tr');
  }

  /** TCKN ana ekranda maskeli: 120 *** ** 06. */
  get maskeliTckn(): string {
    const t = String(this.PersonelInfo?.tckn ?? '');
    return t.length >= 5 ? `${t.slice(0, 3)} *** ** ${t.slice(-2)}` : t;
  }

  /** İzin çubuğu: kullanılan / hak edilen (fazla kullanımda dolu). */
  get izinYuzde(): number {
    const o = this.izinOzeti;
    if (!o || !o.hakEdilen) return o && o.kullanilan > 0 ? 100 : 0;
    return Math.max(0, Math.min(100, (o.kullanilan / o.hakEdilen) * 100));
  }

  /** dtokgoz 02.10: "İzinlerim" → kişinin izin listesi formu. */
  openIzinlerim() {
    if (!this.personelVar) return; // DKM-5104: personeli olmayanda düğme pasif
    this.formuAc('/IKA/IkaPersonelIzinlerimForm');
  }

  private formuAc(yol: string) {
    if (this.router.url != '/main/dabnet') {
      this.router.navigate(['/main/dabnet']);
    }
    const request = new GetFormMetadata_Request({ formAd: yol, altFormAd: '', kod: 0, logYn: false });
    this.ortakService.getFormMetadata(request).pipe(tap((response) => {
      if (response) {
        this.navService.addButtonHandler({
          path: yol,
          text: response.formMetadata?.formTitle || 'Başlık yok',
          data: { sendedData: {} },
        });
      }
    })).subscribe();
  }

  // ---------------- Telefon Rehberi ----------------
  private rehberYukle() {
    this.dataSource?.load()
      .then((liste: any[]) => {
        const sayac = new Map<string, number>();
        this.rehber = (liste ?? []).map((x: any) => {
          const ad = String(x.AdiSoyadi ?? '').trim();
          const birim = String(x.Gorev ?? '').trim();
          if (birim) sayac.set(birim, (sayac.get(birim) ?? 0) + 1);
          return {
            ...x,
            harf: ad.split(/\s+/).filter(Boolean).slice(0, 2).map((p: string) => p[0]).join('').toLocaleUpperCase('tr'),
            renk: OpeningScreenComponent.AVATAR_RENKLERI[this.hash(birim || ad) % OpeningScreenComponent.AVATAR_RENKLERI.length],
            ara: [ad, birim, x.Dahili, x.TelefonNo].filter(Boolean).join(' ').toLocaleLowerCase('tr'),
            adP: [], birimP: [], dahiliP: [],
          } as RehberKisi;
        }).sort((a, b) => (a.AdiSoyadi ?? '').localeCompare(b.AdiSoyadi ?? '', 'tr'));
        this.birimler = [...sayac.entries()]
          .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'tr'))
          .map(([ad, sayi]) => ({ ad, sayi, kisa: ad.replace(/\s*Müdürlüğü$/i, '') }));
        this.rehberYuklendi = true;
        this.suz();
      })
      .catch(() => (this.rehberYuklendi = true));
  }

  rehberAra(metin: string) {
    this.aramaMetni = (metin ?? '').trim();
    this.suz();
  }

  birimSec(birim: string | null) {
    this.seciliBirim = birim;
    this.suz();
  }

  private suz() {
    const q = this.aramaMetni.toLocaleLowerCase('tr');
    this.suzulmus = this.rehber.filter((k) => (!this.seciliBirim || k.Gorev === this.seciliBirim) && (!q || k.ara.includes(q)));
    for (const k of this.suzulmus) {
      k.adP = this.parcala(k.AdiSoyadi, q);
      k.birimP = this.parcala(k.Gorev, q);
      k.dahiliP = this.parcala(k.Dahili || '—', q);
    }
    this.fotoIste(0, 20);
  }

  private parcala(metin: string | undefined, q: string): AramaParca[] {
    const m = metin ?? '';
    const i = q ? m.toLocaleLowerCase('tr').indexOf(q) : -1;
    if (i < 0) return [{ m, e: false }];
    return [{ m: m.slice(0, i), e: false }, { m: m.slice(i, i + q.length), e: true }, { m: m.slice(i + q.length), e: false }].filter((p) => p.m);
  }

  rehberKaydir(liste: HTMLElement) {
    const h = OpeningScreenComponent.SATIR_YUKSEKLIK;
    const bas = Math.floor(liste.scrollTop / h);
    this.fotoIste(bas, bas + Math.ceil(liste.clientHeight / h) + 4);
  }

  kisiKodu(_: number, k: RehberKisi) {
    return k.PersonelKod ?? k.AdiSoyadi;
  }

  fotoAl(k: RehberKisi): string | null {
    return k.PersonelKod ? this.fotolar.get(k.PersonelKod) ?? null : null;
  }

  /** Sunucudan gelen fotoğraf açılamazsa baş harfe dön. */
  fotoHata(k: RehberKisi) {
    if (k.PersonelKod) this.fotolar.set(k.PersonelKod, null);
  }

  kopyala(deger: string) {
    navigator.clipboard?.writeText(String(deger)).then(
      () => notify({ message: `Dahili ${deger} kopyalandı`, width: 'auto', position: { at: 'bottom center', my: 'bottom center', offset: '0 -40' } }, 'success', 1500),
      () => undefined
    );
  }

  /** Görünen aralıktaki fotoğrafları sıraya alır; aynı anda en çok 4 istek. */
  private fotoIste(bas: number, son: number) {
    for (const k of this.suzulmus.slice(bas, son)) {
      if (k.PersonelKod && !this.fotolar.has(k.PersonelKod)) {
        this.fotolar.set(k.PersonelKod, null);
        this.fotoKuyrugu.push(k.PersonelKod);
      }
    }
    while (this.fotoCalisan < 4 && this.fotoKuyrugu.length) this.fotoCek(this.fotoKuyrugu.shift() as number);
  }

  private async fotoCek(personelKod: number) {
    this.fotoCalisan++;
    try {
      const resim = await this.ortManuelService.GetResim_Request(
        new GetResim_Request({ resimKod: personelKod, sourceType: ResimSourceType.personel, base64Yn: 1 })
      );
      if (resim?.response?.result && resim.response.base64) this.fotolar.set(personelKod, resim.response.base64);
    } catch {
      // fotoğraf yoksa baş harf kalır
    } finally {
      this.fotoCalisan--;
      if (this.fotoKuyrugu.length) this.fotoCek(this.fotoKuyrugu.shift() as number);
    }
  }

  private hash(metin: string): number {
    let h = 0;
    for (let i = 0; i < metin.length; i++) h = (h * 31 + metin.charCodeAt(i)) | 0;
    return Math.abs(h);
  }

  onIzinBelgesiIstegi(){

  }

  openBordro(){
      if (!this.personelVar) return; // DKM-5104: personeli olmayanda düğme pasif
      if(this.router.url != '/main/dabnet') {
        this.router.navigate(['/main/dabnet']);
      }
       const request = new GetFormMetadata_Request({
             formAd: '/IKA/IkaBordrolarimForm',
             altFormAd: '',
             kod: 0,
             logYn: false
           })
           this.ortakService.getFormMetadata(request).pipe(tap((response)=> {
               if (response) {
                var routeData:any ={
                  path: '/IKA/IkaBordrolarimForm',
                  text: response.formMetadata.formTitle || 'Başlık yok',
                  data: { sendedData: { }}
                }
               this.navService.addButtonHandler(routeData);
            }
           })).subscribe()
    }
  async setTimeOutSayac() {
    const resSayac = await this.ortManuelService.GetGorevSayac_Request(
      new GetGorevSayac_Request({ sayacTur: 'tum' })
    );

    if (resSayac?.response?.result) {
      const bildirimListesi = resSayac.response.gorevSayacList;

      this.sideBarItems.forEach((item) => {
        const eslesen = bildirimListesi.find(
          (x: any) => x.gorevTipi === item.value
        );
        if (eslesen) {
          const adet = eslesen.adet || 0;
          item.count =adet;
          item.routeLink = eslesen.url || '';
        }
      });
    }
  }

  /** Analiz Merkezi kartı yalnız menüsünde Analiz Merkezi olan kullanıcıda etkin. */
  get analizMerkeziYetkili$() {
    return this.navService.analizMerkeziYetkili$;
  }

  clickSideBarItems(item: any) {
    if (item?.bos) return;
    this.selectedItem = item;
    switch (this.selectedItem.value) {
      case 'AnalizMerkezi':
        this.navService.analizMerkeziniAc(this.router);
        break;
      case 'Takvim':
        // GOR (Takvim) eski hâli: DevExtreme şablon demosu
        // this.router.navigate(['/main/schedular']);
        this.navService.takvimiAc(this.router);
        break;
      case 'İş':
        // GOR (Görevlerim) eski hâli: DevExtreme şablon demosu
        // this.router.navigate(['/main/task']);
        this.navService.gorevlerimiAc(this.router);
        break;
      case 'GenReportTalepForm':
        this.openFormClick(this.selectedItem);
        break;
      case 'Destek':
        // 18.10.2026: kullanıcının kendi destek talepleri (HLP, vHlpBasvurularim; açıksa o sekmeye geçer)
        if (this.router.url != '/main/dabnet') this.router.navigate(['/main/dabnet']);
        this.navService.openOrFocusTab({ path: '/HLP/HlpTaleplerim', text: 'Destek Taleplerim', data: {} });
        break;
      case 'İzin':
        this.changeEvent({
          visible: true,
          value: item.value,
        });
        break;
      case 'GenBildirim':
        this.changeEvent({
          visible: true,
          value: item.value,
        });
        break;
      case 'Duyuru':
        this.changeEvent({
          visible: true,
          value: item.value,
        });
        break;
      case 'BysImza':
        this.openFormClick(this.selectedItem);
        break;
      case 'BysHavale':
        this.openFormClick(this.selectedItem);
        break;
      case 'BysGidenEvrakKayit':
        this.openFormClick(this.selectedItem);
        break;
      case 'BysTaslakRed':
        this.openFormClick(this.selectedItem);
        break;
      case 'BysBirimGelenEvrakKayit':
        this.openFormClick(this.selectedItem);
        break;
      default:
        break;
    }
  }

  changeEvent(item:any){
    window.dispatchEvent(new CustomEvent('genBildirimEvent', { detail: item }));
  }

  openFormClick(item: any) {
    if (this.router.url != '/main/dabnet') {
      this.router.navigate(['/main/dabnet']);
    }
    const request = new GetFormMetadata_Request({
      formAd: item.routeLink,
      altFormAd: '',
      kod: 0,
      logYn: false,
    });
    this.ortakService
      .getFormMetadata(request)
      .pipe(
        tap((response) => {
          if (response) {
             var routeData:any ={
                  path: item.routeLink,
                  text: response.formMetadata.formTitle || 'Başlık yok',
                  data: { sendedData: { }}
                }
                if(item.listeTuru) routeData.data.sendedData.listeTuru = item.listeTuru;
               this.navService.addButtonHandler(routeData);
          }
        })
      )
      .subscribe();
  }

  closeAfterPopup(e: any) {
    this.isPopoverVisible = false;
  }
  /** Açılışta kurulan 2 dk'lık sayaç yenileme zamanlayıcısı; ekran kapanınca iptal edilir. */
  private sayacZamanlayici?: ReturnType<typeof setTimeout>;

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    clearTimeout(this.sayacZamanlayici);

  }
  addItem(condition: any, text: string, value: any) {
    return condition ? { text, value } : null;
  }


}
